import React from 'react'
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSyncDocumentationsMutation } from '../../../api/documentationApiSlice';
import Icon from '../../../components/Icon';
import DocumentationTab from '../../../components/sdk/DocumentationTab';
import Title from '../../../components/Title';

const Documentation = () => {
  const { t } = useTranslation();
  const [sync] = useSyncDocumentationsMutation();

  return ( <>
    <Title main={"SDK"} sub={"Documentation"}>
      <Button onClick={()=>(sync())}>
        <Icon icon='sync' text={t("sync")}/>
      </Button>
    </Title>
    <DocumentationTab/>
  </> );
}

export default Documentation;